import { render, staticRenderFns } from "./NewGaau.vue?vue&type=template&id=04b99be6&"
import script from "./NewGaau.vue?vue&type=script&lang=js&"
export * from "./NewGaau.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports